<template>
  <div>
    <Breadcrumbs :breadcrumbs="[
    {title: this.$t(`menu.${serviceSlug}`), disabled: true},
    {title: this.$t('menu.iframe/statistics'), disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>

    </Breadcrumbs>

    <ProjectsTable
      :parentRef="'iframeProjectsStatisticsTable'"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :showProjectSelection="false"
      @filters-updated="onFiltersUpdated"
      @flowClicked="onFlowClicked"
      :component="component"
      :filtersOptions="['created_at', 'client']"
      :clientOptions="clientOptions"
    />

    <FlowStatsModal
      :flow="selectedFlow"
      v-if="showFlowStatsModal"
      @modalClosed="modalClosed"
    />

  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
import Filters from '@/components/common/Filters'
import IndexTablesMixin from "@/mixins/IndexTablesMixin.vue";
import {TABLE_IFRAME_PROJECTS_STATISTICS} from "@/local-storage/LocalStorageKeys";
import ProjectsTable from "@/components/iframe/project-builder/ProjectsTable.vue";
import FlowStatsModal from "@/components/iframe/statistics/FlowStatsModal.vue";

export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
  },
  mixins: [IndexTablesMixin],
  components: { FlowStatsModal, ProjectsTable, Filters, Breadcrumbs },
  data () {
    return {
      querySearch: '',
      showFilters: true,
      activeFilters: 0,
      localStorageKey: TABLE_IFRAME_PROJECTS_STATISTICS,
      customQueries: null,
      selectedFlow: null,
      showFlowStatsModal: false
    }
  },
  methods: {
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onFlowClicked: function (row) {
      this.selectedFlow = row
      this.showFlowStatsModal = true
    },
    modalClosed: function () {
      this.selectedFlow = null
      this.showFlowStatsModal = false
    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      const statsPerms = this.iframeService.user_permissions.filter(elem => elem.info_type === 120)
      if (statsPerms.some(elem => elem.entity_id === null)) {
        return this.iframeService.entities
      } else {
        const consideredEntitiesIds = statsPerms.map(elem => elem.entity_id)
        return this.iframeService.entities.filter(entity => consideredEntitiesIds.includes(entity.id))
      }
      return []
    }
  }
};
</script>

<style scoped>

</style>
